import React, { memo } from 'react';
import ProductCard from './ProductCard';
import PlaceholderCard from './PlaceholderCard';
import { useCart } from './CartContext';

const ProductsList = ({ Products = [], loading }) => {
    const { loadingProductId, handleAddToCart } = useCart();

    const placeholders = Array.from({ length: 16 }, (_, index) => index);
    
    return (
        <div className="products-list d-grid mt-5">
            {loading && Products.length === 0
                ? placeholders.map((placeholder) => <PlaceholderCard key={placeholder} />)
                : Products.filter((Product) => Product.active == 1).map((Product) => (
                      <ProductCard
                          key={Product.id_product}
                          product={Product}
                          loadingProductId={loadingProductId}
                          handleAddToCart={handleAddToCart}
                      />
                  ))}
        </div>
    );
};

export default ProductsList;
